<template>
  <v-dialog
    v-model="show"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card height="70%" flat tile>
      <v-toolbar dark color="secondary">
        <v-btn icon dark @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>App Account Details</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-sheet height="90%" v-if="user">
        <v-container class="fill-height align-start" fluid>
          <v-row align="start">
            <v-col cols="12">
              <v-list color="transparent">
                <v-list-item class="pl-0 pr-0">
                  <UserAvatar :usersInitials="usersInitials"> </UserAvatar>

                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium"
                      >{{ user.firstName + " " + user.lastName }}
                    </v-list-item-title>
                    <v-list-item-subtitle
                      >{{ user.email }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" class="mt-0 pt-0">
              <!---Start: Aggregate cards---->
              <v-card flat class="py-0">
                <v-card-text class="d-flex justify-start px-0 py-0">
                  <v-card flat outlined rounded="lg" class="mr-4" width="25%">
                    <v-list-item>
                      <IconContainer
                        size="50"
                        imagePath="badge.png"
                        color="pink"
                      />

                      <v-list-item-content class="ml-2">
                        <v-list-item-subtitle
                          >Total Business Cards</v-list-item-subtitle
                        >
                        <v-list-item-title class="text-h6">{{
                          businessCards.length
                        }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>

                  <v-card flat outlined rounded="lg" class="mr-4" width="25%">
                    <v-list-item>
                      <IconContainer imagePath="suitcase.png" size="50" />

                      <v-list-item-content class="ml-2">
                        <v-list-item-subtitle
                          >Total Business Profiles</v-list-item-subtitle
                        >
                        <v-list-item-title class="text-h6"
                          >{{ associatedBusinessProfiles.length }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-card-text>
              </v-card>
              <!---End: Aggregate cards---->
            </v-col>
            <v-col cols="12">
              <v-tabs v-model="tab">
                <v-tab class="text-capitalize">Business Cards</v-tab>
                <v-tab class="text-capitalize">Business Profile Access</v-tab>
                <v-tab class="text-capitalize" v-if="showAppOnboardingProgress"
                  >App Onboarding Progresss</v-tab
                >
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-data-table
                    :headers="businessCardHeaders"
                    :items="businessCards"
                    :items-per-page="8"
                    cl
                  >
                    <template v-slot:item.avatar="{ item }">
                      <UserAvatar
                        :key="`avatar${item.email}`"
                        :usersInitials="item.firstName[0] + item.lastName[0]"
                        :displayImageUrl="item.displayImageUrl || ''"
                      />
                    </template>
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        label
                        :color="
                          getStatusColor(item.status) +
                          '--text ' +
                          getStatusColor(item.status) +
                          ' lighten-5'
                        "
                        class="font-weight-medium text-capitalize"
                        dark
                        small
                        >{{ item.status }}</v-chip
                      >
                    </template>
                  </v-data-table>
                </v-tab-item>
                <v-tab-item>
                  <v-data-table
                    :headers="associatedBusinessProfileHeaders"
                    :items="associatedBusinessProfiles"
                    :items-per-page="8"
                  >
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        label
                        :color="
                          getStatusColor(item.status) +
                          '--text ' +
                          getStatusColor(item.status) +
                          ' lighten-5'
                        "
                        class="font-weight-medium text-capitalize"
                        dark
                        small
                        >{{ item.status }}</v-chip
                      >
                    </template>
                    <template v-slot:item.privilegeLevel="{ item }">
                      <span class="text-capitalize">{{
                        item.privilegeLevel
                      }}</span>
                    </template>
                  </v-data-table>
                </v-tab-item>
                <v-tab-item v-if="showAppOnboardingProgress">
                  <v-stepper vertical class="elevation-0">
                    <v-stepper-step
                      step="1"
                      :complete="user.hasOnBoardGeneralDetailsCompleted"
                    >
                      General details added
                    </v-stepper-step>

                    <v-stepper-content step="1"> </v-stepper-content>
                    <v-stepper-step
                      step="2"
                      :complete="user.hasOnBoardContactDetailsCompleted"
                    >
                      Contact details added
                    </v-stepper-step>

                    <v-stepper-content step="2"> </v-stepper-content>

                    <v-stepper-step
                      step="3"
                      :complete="user.hasOnBoardDisplayPhotoCompleted"
                    >
                      Display picture uploaded
                    </v-stepper-step>
                    <v-stepper-content step="3"> </v-stepper-content>

                    <v-stepper-step
                      step="4"
                      :complete="user.hasOnBoardBackgroundImageCompleted"
                    >
                      Background image uploaded
                    </v-stepper-step>
                  </v-stepper>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-card>
  </v-dialog>
</template>

<script>
import UserAvatar from "@/components/UserAvatar";
import IconContainer from "@/components/IconContainer";

export default {
  props: {
    show: { type: Boolean, default: false },
    cardholders: {
      type: Array,
      default: function () {
        return [];
      },
    },
    businessPortalAccess: {
      type: Array,
      default: function () {
        return [];
      },
    },
    users: {
      type: Array,
      default: function () {
        return [];
      },
    },
    uid: { type: String, default: "" },
  },
  components: {
    UserAvatar,
    IconContainer,
  },
  computed: {
    businessCards() {
      let businessCards = this.cardholders.filter((cardholder) => {
        return cardholder.uid == this.uid;
      });
      return businessCards;
    },
    associatedBusinessProfiles() {
      let associatedBusinessProfiles = this.businessPortalAccess.filter(
        (item) => {
          return item.uid == this.uid;
        }
      );
      return associatedBusinessProfiles;
    },
    user() {
      return this.users.find((user) => user.id == this.uid) || null;
    },
    usersInitials() {
      if (this.user) return this.user.firstName[0] + this.user.lastName[0];
      else return "";
    },
    showAppOnboardingProgress() {
      if (
        this.user.hasOnBoardGeneralDetailsCompleted != undefined ||
        this.user.hasOnBoardContactDetailsCompleted != undefined ||
        this.user.hasOnBoardDisplayPhotoCompleted != undefined ||
        this.user.hasOnBoardBackgroundImageCompleted != undefined
      )
        return true;
      else return false;
    },
  },
  data() {
    return {
      associatedBusinessProfileHeaders: [
        {
          text: "Business Name",
          align: "left",
          value: "businessName",
        },
        {
          text: "Email",
          align: "left",
          value: "email",
        },
        {
          text: "Privilege Level",
          align: "left",
          value: "privilegeLevel",
        },

        {
          text: "Status",
          align: "left",
          value: "status",
        },
      ],
      businessCardHeaders: [
        {
          text: "",
          align: "right",
          value: "avatar",
          sortable: false,
        },
        {
          text: "First Name",
          align: "left",
          value: "firstName",
        },
        {
          text: "Last Name",
          align: "left",
          value: "lastName",
        },
        {
          text: "Email",
          align: "left",
          value: "email",
        },
        {
          text: "Business Name",
          align: "left",
          value: "businessName",
        },
        {
          text: "Subscription type",
          align: "left",
          value: "subscriptionType",
        },
        {
          text: "Status",
          align: "left",
          value: "status",
        },
      ],
      tab: 0,
      onboardingProgress: 2,
    };
  },
  methods: {
    getStatusColor(status) {
      if (status) {
        if (status.toLowerCase() == "active") return "green";
        else if (status.toLowerCase() == "pending") return "orange";
        else if (status.toLowerCase() == "declined") return "red";
        else return "red";
      }
    },
  },
};
</script>

<style scoped>
/* ::v-deep v-stepper {
  box-shadow: unset !important;
  border-radius: 4px;
  overflow: unset;
  position: unset;
}

.v-stepper__header {
  border: 0px;
  box-shadow: unset;
}

.v-stepper__items {
  height: 100%;
} */
</style>